import React from 'react';

import { Container, Label, SupportText } from '../InformationBlocks.styled';

export interface Props {
    ucasCode: string;
    institutionCode: string;
}

const UCASCode: React.FC<Props> = props => {
    const { ucasCode, institutionCode } = props;

    return (
        <Container>
            <Label>
                UCAS code: <strong>{ucasCode}</strong>
            </Label>
            <SupportText>Institution code: {institutionCode}</SupportText>
        </Container>
    );
};

export default UCASCode;
